export default "<p>input-email-control works!</p>\n"